import React from "react";
import { MapPin, Navigation, Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function StepsFromTheSacred() {
  return <section data-section-id="224794" id="i-nostri-uffici" className="bg-background text-foreground w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-[600px] lg:min-h-[800px]">
        
        {}
        <div className="lg:col-span-7 relative bg-primary flex items-center justify-center min-h-[400px] lg:min-h-auto overflow-hidden group">
          {}
          <div className="absolute inset-0 bg-cover bg-center opacity-40 transition-transform duration-1000 group-hover:scale-105" style={{
          backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_map_navy.png')"
        }} />
          
          {}
          <div className="absolute inset-0 bg-gradient-to-r from-primary/80 via-transparent to-transparent lg:hidden" />
          <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-transparent to-transparent lg:hidden" />

          {}
          <div className="relative z-10 w-full max-w-md aspect-square flex items-center justify-center">
            {}
            <div className="flex flex-col items-center">
              <div className="bg-secondary text-secondary-foreground p-5 rounded-sm shadow-xl shadow-secondary/20 mb-4 relative">
                <div className="absolute inset-0 rounded-sm border-2 border-secondary animate-ping opacity-30" />
                <MapPin className="size-10" />
              </div>
              <span className="text-secondary font-default font-bold text-xl tracking-widest bg-primary/90 px-6 py-2 rounded-sm backdrop-blur-md border border-secondary/30 shadow-2xl">
                PADOVA
              </span>
              <p className="text-white/60 text-xs mt-3 uppercase tracking-[0.2em] font-semibold">Sede Unica Nazionale</p>
            </div>

            {}
            <div className="absolute top-8 left-8 bg-primary/95 backdrop-blur-md border border-secondary/20 p-4 rounded-sm shadow-2xl flex items-center gap-4">
              <div className="bg-secondary/10 p-2 rounded-sm">
                <Clock className="size-5 text-secondary" />
              </div>
              <div>
                <p className="text-xs text-secondary/70 uppercase tracking-wider font-semibold">ORARIO DI RICEVIMENTO:</p>
                <p className="text-secondary font-default font-bold text-lg">Su Appuntamento</p>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="lg:col-span-5 bg-primary flex flex-col justify-center p-8 sm:p-12 lg:p-16 xl:p-24 relative z-20">
          {}
          <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,_var(--secondary)_1px,_transparent_1px)] bg-[size:24px_24px]" />
          
          <div className="relative z-10 max-w-xl">
            <Badge variant="outline" className="mb-8 border-secondary text-secondary bg-secondary/5 px-4 py-1.5 text-sm uppercase tracking-widest font-semibold">
              Ufficio Unico
            </Badge>
            
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-default font-bold text-white mb-6 leading-tight">
              La Nostra Sede
            </h2>
            
            <div className="space-y-6 text-white/80 text-lg sm:text-xl font-default leading-relaxed">
              <p>
                WORLD IMMIGRATION DI DELGADO concentra la propria eccellenza operativa nella sede storica di Padova. Un unico punto di riferimento strategico per gestire con la massima precisione e riservatezza ogni pratica di mobilità internazionale, visti e servizi corporate.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>;
}